import React, { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router'
import { useAuth } from '../../hooks/useAuth'
import * as Mtds from '@mattilsynet/design/react'
import { AppLayout } from '../app-layout/AppLayout'

interface RoleGuardProps {
  requiredRoles: string[]
}

function PendingAccess() {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300)
    return () => clearTimeout(timer)
  }, [])
  return visible ? (
    <AppLayout isLoading loadingMessage='Laster tilganger …' />
  ) : null
}

const RoleGuard: React.FC<RoleGuardProps> = ({ requiredRoles }) => {
  const { roles, accessPending, accessError, accessRefreshing, retryAccess } =
    useAuth()
  if (accessError)
    return (
      <Mtds.Prose>
        <Mtds.Alert data-color='danger'>
          Kunne ikke hente tilgangene dine. Prøv igjen; dette betyr ikke at du
          mangler tilgang.
        </Mtds.Alert>
        <Mtds.Button
          disabled={accessRefreshing}
          onClick={() => void retryAccess?.()}
        >
          {accessRefreshing ? 'Prøver igjen …' : 'Prøv igjen'}
        </Mtds.Button>
      </Mtds.Prose>
    )
  if (accessPending) return <PendingAccess />

  const hasRequiredRole = requiredRoles.some((role) => roles?.includes(role))

  if (!hasRequiredRole) {
    return <Navigate to='/unauthorized' replace />
  }

  return <Outlet />
}

export default RoleGuard
